function canonicalPath(pathname) {
  const p = pathname || '/';
  if (p === '/' || p === '') return '/';
  return p.replace(/\/+$/, '') || '/';
}

/**
 * Full document navigation so the page loads from the top.
 * If the user is already on that path (e.g. scrolled to the bottom), reloads.
 */
export function navigatePublicMarketingPage(path) {
  const [pathname, hashPart = ''] = String(path).split('#');
  const target = canonicalPath(pathname);
  const current = canonicalPath(window.location.pathname);
  const targetHash = hashPart ? `#${hashPart}` : '';

  if (current === target) {
    if (targetHash && window.location.hash !== targetHash) {
      window.location.hash = hashPart;
      return;
    }
    window.location.reload();
  } else {
    window.location.assign(targetHash ? `${target}${targetHash}` : target);
  }
}

export function publicMarketingNavClick(path) {
  return (event) => {
    event.preventDefault();
    navigatePublicMarketingPage(path);
  };
}
